import { Check, Circle } from 'lucide-react';
import {
  isBenefitComplete,
  isPerksComplete,
  isPricingComplete,
  type CreatorDraftPayload,
} from './draftSchema';

type Props = {
  payload: CreatorDraftPayload;
};

const NAME_MIN_LENGTH = 1;

const ReadyToPublishChecklist = ({ payload }: Props) => {
  const nameOk = String(payload.name || '').trim().length >= NAME_MIN_LENGTH;
  const themeOk = Boolean(payload.cardTheme);
  const pricingOk = isPricingComplete(payload);
  const benefitOk = isBenefitComplete(payload);
  const perksOk = isPerksComplete(payload);

  const items: Array<{ key: string; label: string; done: boolean }> = [
    { key: 'name', label: 'Membership name added', done: nameOk },
    { key: 'theme', label: 'Card theme selected', done: themeOk },
    { key: 'pricing', label: 'Validity & price set', done: pricingOk },
    { key: 'benefit', label: 'Main benefit configured', done: benefitOk },
    { key: 'perks', label: 'At least one perk added', done: perksOk },
  ];

  return (
    <ul className="ready-checklist" data-testid="ready-checklist">
      {items.map((item) => (
        <li
          key={item.key}
          className={`ready-checklist__item${item.done ? ' ready-checklist__item--done' : ''}`}
          data-testid={`ready-checklist-${item.key}`}
        >
          <span className="ready-checklist__icon" aria-hidden="true">
            {item.done ? <Check size={14} /> : <Circle size={14} />}
          </span>
          <span className="ready-checklist__label">{item.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default ReadyToPublishChecklist;
